// NOTE: vital names cannot contain spaces or special characters

export enum DatadogDurationVital {
  SESSION_TEMPLATE_DIALOG_OPEN = 'sessionTemplateDialogOpen',
  SESSION_TAB_CHANGE = 'sessionTabChange',
  START_DICTATION = 'startDictation',
  STOP_DICTATION = 'stopDictation',
  LINKED_SESSIONS_DROPDOWN_OPEN = 'linkedSessionsDropdownOpen',
  EMBEDDINGS_PANEL_OPEN = 'embeddingsPanelOpen',
  NEW_SESSION = 'newSession',
  SESSION_START_RECORDING = 'sessionStartRecording',
  SESSION_PAUSE_RECORDING = 'sessionPauseRecording',
  SESSION_RESUME_RECORDING = 'sessionResumeRecording',
  SESSION_STOP_RECORDING = 'sessionStopRecording',
  TEMPLATE_CLICK = 'templateClick',
  SESSION_SEARCH_RENDERED_V3 = 'sessionSearchRenderedV3',
  SESSION_SEARCH_RENDERED_V2 = 'sessionSearchRenderedV2',
  SESSION_SEARCH_RENDERED_V1 = 'sessionSearchRenderedV1',
}
